import React, {
    useEffect,
    useState,
  } from "react";
  
  import {
    collection,
    query,
    where,
    onSnapshot,
  } from "firebase/firestore";
  
  import {
    FaChevronDown,
    FaChevronUp,
    FaTrophy,
  } from "react-icons/fa";
  
  import { db } from "../firebase";
  
  import "./EarningRecord.css";
  
  
  export default function Earning() {
  
    // =====================================================
    // USERNAME
    // =====================================================
  
    const username =
      localStorage.getItem("username") || "";
  
  
    // =====================================================
    // STATE
    // =====================================================
  
    const [records, setRecords] =
      useState([]);
  
    const [loading, setLoading] =
      useState(true);
  
    const [openId, setOpenId] =
      useState(null);
  
  
    // =====================================================
    // TIMESTAMP
    // =====================================================
  
    const getTimestamp = (record) => {
  
      // Firestore Timestamp - createdAt
      if (
        record?.createdAt?.seconds
      ) {
  
        return (
          Number(
            record.createdAt.seconds
          ) * 1000
        );
  
      }
  
  
      // Firestore Timestamp - paidAt
      if (
        record?.paidAt?.seconds
      ) {
  
        return (
          Number(
            record.paidAt.seconds
          ) * 1000
        );
  
      }
  
  
      // Firestore Timestamp - timestamp
      if (
        record?.timestamp?.seconds
      ) {
  
        return (
          Number(
            record.timestamp.seconds
          ) * 1000
        );
  
      }
  
  
      // Match timestamp
      if (
        record?.matchTimestamp?.seconds
      ) {
  
        return (
          Number(
            record.matchTimestamp.seconds
          ) * 1000
        );
  
      }
  
  
      // Number createdAt
      if (
        typeof record?.createdAt ===
        "number"
      ) {
  
        return Number(
          record.createdAt
        );
  
      }
  
  
      // Number paidAt
      if (
        typeof record?.paidAt ===
        "number"
      ) {
  
        return Number(
          record.paidAt
        );
  
      }
  
  
      return 0;
  
    };
  
  
    // =====================================================
    // LOAD WINNING RECORDS
    // =====================================================
  
    useEffect(() => {
  
      if (!username) {
  
        setRecords([]);
  
        setLoading(false);
  
        return;
  
      }
  
  
      setLoading(true);
  
  
      let antRecords = [];
  
      let correctRecords = [];
  
  
      // ===================================================
      // UPDATE COMBINED RECORDS
      // ===================================================
  
      const updateRecords = () => {
  
        const combined = [
  
          ...antRecords,
  
          ...correctRecords,
  
        ];
  
  
        // =================================================
        // ONLY WIN RESULTS
        // =================================================
  
        const winningRecords =
          combined.filter(
            (record) => {
  
              const result =
                String(
                  record?.result || ""
                )
                  .trim()
                  .toLowerCase();
  
              return result === "win";
  
            }
          );
  
  
        // =================================================
        // NEWEST FIRST
        // =================================================
  
        winningRecords.sort(
          (a, b) => {
  
            return (
              getTimestamp(b) -
              getTimestamp(a)
            );
  
          }
        );
  
  
        setRecords(
          winningRecords
        );
  
        setLoading(false);
  
      };
  
  
      // ===================================================
      // ANTSCORE
      // ===================================================
  
      const antQuery =
        query(
          collection(
            db,
            "antscore"
          ),
  
          where(
            "username",
            "==",
            username
          )
        );
  
  
      // ===================================================
      // CORRECTSCORE
      // ===================================================
  
      const correctQuery =
        query(
          collection(
            db,
            "correctscore"
          ),
  
          where(
            "username",
            "==",
            username
          )
        );
  
  
      // ===================================================
      // ANTSCORE SNAPSHOT
      // ===================================================
  
      const unsubscribeAnt =
        onSnapshot(
  
          antQuery,
  
          (snapshot) => {
  
            antRecords =
              snapshot.docs.map(
                (item) => ({
  
                  id:
                    item.id,
  
                  ...item.data(),
  
                  recordSource:
                    "antscore",
  
                })
              );
  
  
            updateRecords();
  
          },
  
          (error) => {
  
            console.error(
              "antscore earning error:",
              error
            );
  
            antRecords = [];
  
            updateRecords();
  
          }
  
        );
  
  
      // ===================================================
      // CORRECTSCORE SNAPSHOT
      // ===================================================
  
      const unsubscribeCorrect =
        onSnapshot(
  
          correctQuery,
  
          (snapshot) => {
  
            correctRecords =
              snapshot.docs.map(
                (item) => ({
  
                  id:
                    item.id,
  
                  ...item.data(),
  
                  recordSource:
                    "correctscore",
  
                })
              );
  
  
            updateRecords();
  
          },
  
          (error) => {
  
            console.error(
              "correctscore earning error:",
              error
            );
  
            correctRecords = [];
  
            updateRecords();
  
          }
  
        );
  
  
      // ===================================================
      // CLEANUP
      // ===================================================
  
      return () => {
  
        unsubscribeAnt();
  
        unsubscribeCorrect();
  
      };
  
    }, [username]);
  
  
    // =====================================================
    // FORMAT DATE
    // =====================================================
  
    const formatDate = (record) => {
  
      const timestamp =
        getTimestamp(record);
  
  
      if (!timestamp) {
  
        return "--/--/----";
  
      }
  
  
      const date =
        new Date(timestamp);
  
  
      return date.toLocaleDateString(
        "en-GB",
        {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
        }
      );
  
    };
  
  
    // =====================================================
    // FORMAT TIME
    // =====================================================
  
    const formatTime = (record) => {
  
      /*
        Kwanza tunatumia createdAt/paidAt
        kwa earning record.
  
        Kama hazipo, getTimestamp()
        itajaribu matchTimestamp.
      */
  
      const timestamp =
        getTimestamp(record);
  
  
      if (!timestamp) {
  
        return "--:--";
  
      }
  
  
      return new Date(
        timestamp
      ).toLocaleTimeString(
        "en-GB",
        {
          hour: "2-digit",
          minute: "2-digit",
          hour12: false,
        }
      );
  
    };
  
  
    // =====================================================
    // FORMAT MONEY
    // =====================================================
  
    const formatMoney = (amount) => {
  
      const number =
        Number(amount || 0);
  
  
      if (
        Number.isNaN(number)
      ) {
  
        return "0.00";
  
      }
  
  
      return number.toLocaleString(
        "en-GB",
        {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }
      );
  
    };
  
  
    // =====================================================
    // TYPE
    // =====================================================
  
    const getType = (record) => {
  
      if (
        record?.type ===
        "correctscore"
      ) {
  
        return "Correct Score";
  
      }
  
  
      if (
        record?.recordSource ===
        "correctscore"
      ) {
  
        return "Correct Score";
  
      }
  
  
      if (
        record?.mode ===
        "correct"
      ) {
  
        return "Correct Score";
  
      }
  
  
      return "Antscore";
  
    };
  
  
    // =====================================================
    // WIN AMOUNT
    // =====================================================
  
    const getWinAmount = (record) => {
  
      /*
        Priority:
  
        1. totalWin
        2. stake + profit
        3. amount + profit
        4. amount
      */
  
      if (
        record?.totalWin !==
        undefined &&
        record?.totalWin !==
        null
      ) {
  
        return Number(
          record.totalWin
        );
  
      }
  
  
      const stake =
        Number(
          record?.stake ??
          record?.amount ??
          0
        );
  
  
      const profit =
        Number(
          record?.profit || 0
        );
  
  
      return stake + profit;
  
    };
  
  
    // =====================================================
    // PROFIT
    // =====================================================
  
    const getProfit = (record) => {
  
      return Number(
        record?.profit || 0
      );
  
    };
  
  
    // =====================================================
    // TOGGLE DETAILS
    // =====================================================
  
    const toggleDetails = (id) => {
  
      setOpenId(
        (current) =>
          current === id
            ? null
            : id
      );
  
    };
  
  
    // =====================================================
    // LOADING
    // =====================================================
  
    if (loading) {
  
      return (
  
        <div className="earning-record">
  
          <div className="earning-loading">
  
            Loading earnings...
  
          </div>
  
        </div>
  
      );
  
    }
  
  
    // =====================================================
    // USER NOT FOUND
    // =====================================================
  
    if (!username) {
  
      return (
  
        <div className="earning-record">
  
          <div className="earning-empty">
  
            <div className="earning-empty-icon">
  
              <FaTrophy />
  
            </div>
  
  
            <h3>
              User Not Found
            </h3>
  
  
            <p>
              Please log in again to view your earnings.
            </p>
  
          </div>
  
        </div>
  
      );
  
    }
  
  
    // =====================================================
    // EMPTY WIN RECORDS
    // =====================================================
  
    if (
      records.length === 0
    ) {
  
      return (
  
        <div className="earning-record">
  
          <div className="earning-empty">
  
            <div className="earning-empty-icon">
  
              <FaTrophy />
  
            </div>
  
  
            <h3>
              No Winning Records
            </h3>
  
  
            <p>
              Your winning results will appear here.
            </p>
  
          </div>
  
        </div>
  
      );
  
    }
  
  
    // =====================================================
    // TOTAL EARNINGS
    // =====================================================
  
    const totalEarnings =
      records.reduce(
        (
          total,
          record
        ) => {
  
          return (
            total +
            getProfit(record)
          );
  
        },
        0
      );
  
  
    // =====================================================
    // RETURN
    // =====================================================
  
    return (
  
      <div className="earning-record">
  
  
        {/* =================================================
            HEADER
        ================================================= */}
  
        <div className="earning-header">
  
          <div>
  
            <h2>
              Earning
            </h2>
  
            <p>
              Winning results
            </p>
  
          </div>
  
  
          <div className="earning-total">
  
            <span>
              Profit
            </span>
  
            <strong>
  
              +{formatMoney(
                totalEarnings
              )}
  
            </strong>
  
          </div>
  
  
          <div className="earning-count">
  
            {records.length}
  
          </div>
  
        </div>
  
  
        {/* =================================================
            LIST
        ================================================= */}
  
        <div className="earning-list">
  
          {records.map(
            (record) => {
  
              const uniqueId =
                `${record.recordSource}-${record.id}`;
  
              const isOpen =
                openId === uniqueId;
  
  
              const winAmount =
                getWinAmount(record);
  
  
              const profit =
                getProfit(record);
  
  
              return (
  
                <div
                  key={uniqueId}
                  className={`earning-item ${
                    isOpen
                      ? "is-open"
                      : ""
                  }`}
                >
  
  
                  {/* =======================================
                      MAIN ROW
                  ======================================= */}
  
                  <button
                    type="button"
                    className="earning-main-row"
                    onClick={() =>
                      toggleDetails(
                        uniqueId
                      )
                    }
                  >
  
  
                    {/* TYPE */}
  
                    <div className="earning-main-left">
  
                      <div className="earning-type">
  
                        {getType(
                          record
                        )}
  
                      </div>
  
  
                      <div className="earning-date">
  
                        <span>
  
                          {formatDate(
                            record
                          )}
  
                        </span>
  
  
                        <span className="earning-time">
  
                          {formatTime(
                            record
                          )}
  
                        </span>
  
                      </div>
  
                    </div>
  
  
                    {/* AMOUNT */}
  
                    <div className="earning-main-amount">
  
                      +
                      {formatMoney(
                        winAmount
                      )}{" "}
  
                      {record.currency ||
                        "TZS"}
  
                    </div>
  
  
                    {/* STATUS */}
  
                    <div className="earning-main-status">
  
                      Win
  
                    </div>
  
  
                    {/* ARROW */}
  
                    <div className="earning-arrow">
  
                      {isOpen ? (
  
                        <FaChevronUp />
  
                      ) : (
  
                        <FaChevronDown />
  
                      )}
  
                    </div>
  
  
                  </button>
  
  
                  {/* =======================================
                      DETAILS
                  ======================================= */}
  
                  {isOpen && (
  
                    <div className="earning-details-panel">
  
  
                      {/* RESULT */}
  
                      <div className="earning-detail-row">
  
                        <span>
                          Result
                        </span>
  
  
                        <strong className="earning-win">
  
                          Win
  
                        </strong>
  
                      </div>
  
  
                      {/* TYPE */}
  
                      <div className="earning-detail-row">
  
                        <span>
                          Type
                        </span>
  
  
                        <strong>
  
                          {getType(
                            record
                          )}
  
                        </strong>
  
                      </div>
  
  
                      {/* MATCH */}
  
                      <div className="earning-detail-row">
  
                        <span>
                          Match
                        </span>
  
  
                        <strong>
  
                          {record.teamA ||
                            "Team A"}
  
                          {" vs "}
  
                          {record.teamB ||
                            "Team B"}
  
                        </strong>
  
                      </div>
  
  
                      {/* SCORE */}
  
                      <div className="earning-detail-row">
  
                        <span>
                          Score
                        </span>
  
  
                        <strong>
  
                          {record.score ||
                            "-"}
  
                        </strong>
  
                      </div>
  
  
                      {/* DATE */}
  
                      <div className="earning-detail-row">
  
                        <span>
                          Date
                        </span>
  
  
                        <strong>
  
                          {formatDate(
                            record
                          )}
  
                        </strong>
  
                      </div>
  
  
                      {/* TIME */}
  
                      <div className="earning-detail-row">
  
                        <span>
                          Time
                        </span>
  
  
                        <strong>
  
                          {formatTime(
                            record
                          )}
  
                        </strong>
  
                      </div>
  
  
                      {/* STAKE */}
  
                      <div className="earning-detail-row">
  
                        <span>
                          Stake
                        </span>
  
  
                        <strong>
  
                          {formatMoney(
                            record.stake ??
                            record.amount
                          )}{" "}
  
                          {record.currency ||
                            "TZS"}
  
                        </strong>
  
                      </div>
  
  
                      {/* PROFIT */}
  
                      <div className="earning-detail-row">
  
                        <span>
                          Profit
                        </span>
  
  
                        <strong className="earning-profit">
  
                          +
                          {formatMoney(
                            profit
                          )}{" "}
  
                          {record.currency ||
                            "TZS"}
  
                        </strong>
  
                      </div>
  
  
                      {/* TOTAL WIN */}
  
                      <div className="earning-detail-row">
  
                        <span>
                          Total Win
                        </span>
  
  
                        <strong className="earning-win">
  
                          +
                          {formatMoney(
                            winAmount
                          )}{" "}
  
                          {record.currency ||
                            "TZS"}
  
                        </strong>
  
                      </div>
  
  
                      {/* ODDS */}
  
                      <div className="earning-detail-row">
  
                        <span>
                          Odds
                        </span>
  
  
                        <strong>
  
                          {record.odds ??
                            "-"}%
  
                        </strong>
  
                      </div>
  
  
                      {/* BET ID */}
  
                      <div className="earning-detail-row">
  
                        <span>
                          Bet ID
                        </span>
  
  
                        <strong className="earning-bet-id">
  
                          {record.betId ||
                            "-"}
  
                        </strong>
  
                      </div>
  
  
                    </div>
  
                  )}
  
                </div>
  
              );
  
            }
          )}
  
        </div>
  
      </div>
  
    );
  
  }